module.exports = __webpack_public_path__ + "img/login-orientequiteno.34a75b9a.svg";